import React, { useEffect, useState } from 'react';
import MobileNav from './MobileNav';
import DesktopNav from './DesktopNav';

const Navbar = ({ onNavigate = () => { }, currentPath = '/' }) => {
    const [useMobileNav, setUseMobileNav] = useState(false);

    useEffect(() => {
        const checkScreen = () => {
            setUseMobileNav(window.innerWidth < 1280);
        };

        checkScreen();
        window.addEventListener('resize', checkScreen);
        return () => window.removeEventListener('resize', checkScreen);
    }, []);

    if (useMobileNav) {
        return <MobileNav onNavigate={onNavigate} currentPath={currentPath} />;
    }

    return <DesktopNav onNavigate={onNavigate} currentPath={currentPath} />;
};

export default Navbar;